const mediaItems = [
  {
    title: '久久视频精选合集',
    desc: '久久视频平台优质资源每日精选，为您呈现当下最受欢迎的在线视频内容。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20crimson%20abstract%20digital%20art%20with%20soft%20gradient%2C%20cinematic%20atmosphere%2C%20floating%20geometric%20shapes%2C%20modern%20minimal%20design%2C%20no%20text%2C%20entertainment%20media%20theme%2C%20clean%20aesthetic&width=640&height=400&seq=media-01&orientation=landscape',
    tag: '久久视频',
  },
  {
    title: '芒果视频热播推荐',
    desc: '芒果视频在线视频网站热门内容速递，精选优质视频播放器在线看视频体验。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20golden%20and%20rose%20abstract%20flow%2C%20warm%20digital%20texture%2C%20smooth%20gradient%20waves%2C%20modern%20media%20aesthetic%2C%20no%20text%2C%20cinematic%20lighting%2C%20clean%20composition&width=640&height=400&seq=media-02&orientation=landscape',
    tag: '芒果视频',
  },
  {
    title: '97视频资源速览',
    desc: '97视频平台实时更新在线视频网站入口，帮助用户快速进入视频播放器在线看视频。',
    img: 'https://readdy.ai/api/search-image?query=Rich%20warm%20crimson%20and%20dark%20amber%20abstract%20composition%2C%20layered%20gradients%2C%20modern%20digital%20art%2C%20entertainment%20portal%20vibe%2C%20no%20text%2C%20smooth%20curves%2C%20professional%20quality&width=640&height=400&seq=media-03&orientation=landscape',
    tag: '97视频',
  },
  {
    title: '丝瓜视频精品专区',
    desc: '丝瓜视频在线视频网站精选内容专区，为您打造舒适的视频播放器在线看视频浏览体验。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20abstract%20design%20with%20soft%20overlapping%20shapes%2C%20terracotta%20and%20cream%20palette%2C%20modern%20digital%20minimalism%2C%20no%20text%2C%20cinematic%20atmosphere%2C%20clean%20aesthetic&width=640&height=400&seq=media-04&orientation=landscape',
    tag: '丝瓜视频',
  },
  {
    title: '蓝莓视频最新入口',
    desc: '蓝莓视频在线视频网站最新可用入口汇总，持续更新视频播放器在线看视频站点链接。',
    img: 'https://readdy.ai/api/search-image?query=Sophisticated%20warm%20gradient%20abstract%20art%2C%20deep%20amber%20and%20soft%20peach%20tones%2C%20minimal%20geometric%20design%2C%20media%20platform%20aesthetic%2C%20no%20text%2C%20clean%20composition%2C%20professional%20look&width=640&height=400&seq=media-05&orientation=landscape',
    tag: '蓝莓视频',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          视频资源
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          精选久久视频、芒果视频、97视频、丝瓜视频等在线视频网站资源，提供视频播放器在线看视频入口
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all cursor-pointer">
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-background-50/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}